import {
  Card,
  Tabs,
  TabsProps,
} from "antd";
import { useState } from "react";
import AppHeader from "../layouts/header";
import UrlToCdnCard from "../component/utility/urlToCdnCard";
import ConvertToMp4Card from "../component/utility/convertToMp4Card";
// import HlsPlayer from "../component/utility/player";

export default function Tools() {
  const getActiveTab = () => {
    const params = new URLSearchParams(
      window.location.search
    );

    return params.get("tab") || "1";
  };

  const [activeTab, setActiveTab] =
    useState(getActiveTab());

  const handleTabChange = (
    key: string
  ) => {
    setActiveTab(key);

    const params = new URLSearchParams(
      window.location.search
    );

    params.set("tab", key);

    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${params.toString()}`
    );
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "URL to CDN Converter",
      children: <UrlToCdnCard />,
    },
    {
      key: "2",
      label: "Convert to mp4",
      children: <ConvertToMp4Card />,
    },
    // {
    //   key: "3",
    //   label: "HLS Player",
    //   children: <HlsPlayer />,
    // },
  ];

  return (
    <>
      <AppHeader />
      <Card title="Tools and utility">
        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          items={items}
        />
      </Card>
    </>
  );
}